import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import AxiosCustom from "common/components/apiConfig";
import {
  handleNotificationAlertCatch,
  handleNotificationAlertTrySelect,
} from "common/method/handleNotificationAlert";

// import { handleNotificationAlertTrySelect } from './../../common/method/handleNotificationAlert/index';

export const actionTypes = {
  selectMarketMakerWatchlist: "selectMarketMakerWatchlist [Action]",
  selectMarketMakerWatchlistLoading:
    "selectMarketMakerWatchlistLoading [Action]",
  selectMarketMakerWatchlistAsync: "selectMarketMakerWatchlistAsync [Action]",
};
const inistiaState = {
  data: [],
  loading: false,
  total: 0,
};

export const select_market_maker_watchlist_Reducer = (
  state = inistiaState,
  { type, payload }
) => {
  switch (type) {
    case actionTypes.selectMarketMakerWatchlist:
      return {
        ...state,
        data: payload?.results,
        total: payload?.total,
      };
    case actionTypes.selectMarketMakerWatchlistLoading:
      return {
        ...state,
        loading: payload,
      };
    default:
      return state;
  }
};

function* handleWorker({ payload }) {
  yield put({
    type: actionTypes.selectMarketMakerWatchlistLoading,
    payload: true,
  });

  let config = {
    url: "select_request",
  };

  let data = {
    table: "market_maker",
    method_type: "select_market_maker_watchlist",
    data: payload?.data ? payload.data : {},
    size: 10,
    from_: 0,
  };

  try {
    let res = yield AxiosCustom(config, data);
    let isOk = handleNotificationAlertTrySelect(res);
    if (!isOk) {
      return;
    }
    yield put({
      type: actionTypes.selectMarketMakerWatchlist,
      payload: res?.data?.response?.data,
    });
  } catch {
    handleNotificationAlertCatch();
  } finally {
    yield put({
      type: actionTypes.selectMarketMakerWatchlistLoading,
      payload: false,
    });
  }
}

export function* selectMarketMakerWatchlist() {
  yield takeLatest(actionTypes.selectMarketMakerWatchlistAsync, handleWorker);
}
